import {useState} from 'react'
import {Link} from 'react-router-dom'
import {BRAND, FAQS} from './site'
import {Container, PageHero} from './ui'

const FaqPage = () => {
  const [open, setOpen] = useState<number | null>(0)

  return (
    <div>
      <PageHero title='Frequently asked questions' sub='Everything you need to know before you reserve a bed.' />

      <section style={{padding: '56px 0 72px'}}>
        <Container style={{maxWidth: 800}}>
          {FAQS.map((f, i) => {
            const isOpen = open === i
            return (
              <div
                key={f.q}
                style={{
                  border: `1px solid ${isOpen ? 'rgba(3,149,64,0.35)' : '#eef0f4'}`,
                  borderRadius: 16,
                  marginBottom: 14,
                  overflow: 'hidden',
                  background: '#fff',
                  boxShadow: isOpen ? '0 10px 28px rgba(3,149,64,0.1)' : '0 4px 12px rgba(27,27,41,0.03)',
                  transition: 'border-color 0.2s, box-shadow 0.2s',
                }}
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 16,
                    padding: '20px 22px',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                  }}
                >
                  <span style={{fontSize: 16, fontWeight: 700, color: isOpen ? BRAND.green : BRAND.ink}}>{f.q}</span>
                  <span style={{width: 28, height: 28, flexShrink: 0, borderRadius: '50%', background: 'rgba(3,149,64,0.1)', color: BRAND.green, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, transform: isOpen ? 'rotate(45deg)' : 'none', transition: 'transform 0.2s'}}>+</span>
                </button>
                {isOpen && (
                  <div style={{padding: '0 22px 22px', color: BRAND.muted, fontSize: 15, lineHeight: 1.7}}>{f.a}</div>
                )}
              </div>
            )
          })}

          <div style={{textAlign: 'center', marginTop: 36}}>
            <p style={{color: BRAND.muted, margin: '0 0 14px'}}>Still have a question?</p>
            <Link to='/contact' className='ccp-cta' style={{display: 'inline-block', textDecoration: 'none', fontWeight: 700, color: '#fff', background: BRAND.green, borderRadius: 12, padding: '12px 26px'}}>
              Contact us
            </Link>
          </div>
        </Container>
      </section>
    </div>
  )
}

export {FaqPage}
